import {Component, ElementRef, Inject, Input} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import {NgIf} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';
import { BkButton } from '@brickclay-org/ui';
@Component({
  selector: 'app-confirmation-dialog',
  imports: [
    MatDialogClose,
    MatDialogContent,
    MatDialogActions,
    NgIf,
    BkButton,
    MatTooltip
  ],
  templateUrl: './confirmation-dialog.component.html',
  standalone: true,
  styleUrl: './confirmation-dialog.component.css'
})
export class ConfirmationDialogComponent {
  @Input() title = '';
  @Input() subTitle = '';
  @Input() boldTitle = '';
  @Input() showSubtitle = false;
  @Input() showBoldTitle = false;
  @Input() confirmButtonText = 'Remove Member';

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.subTitle = data.subTitle;
    this.boldTitle = data.boldTitle;
    this.showSubtitle = data.showSubtitle;
    this.showBoldTitle = data.showBoldTitle;
    this.confirmButtonText = data?.confirmButtonText? data.confirmButtonText: this. confirmButtonText;
    // Manually listen for ESC key inside this dialog
    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.dialogAction(false); // only closes this dialog
      }
    });
  }
  dialogAction(action: boolean) {
    this.dialogRef.close(action);
  }
  onDialogClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
